import * as React from 'react';
import { Route, Redirect, Switch, useLocation } from 'react-router-dom';
import Loadable from 'react-loadable';

import { ROOT_REGION_ID_STRING } from 'upstream-shared/constants';
import { UpstreamToken } from 'upstream-shared/models';

import { paths } from '../../paths';

import Home from '../../pages/Home/Home';
import Login from '../../pages/Login/Login';
import Logout from '../../pages/Logout/Logout';
import LoginWithToken from '../../pages/Login/LoginWithToken';
import ListOperators from '../../pages/Operator/ListOperators';
import ViewOperator from '../../pages/Operator/ViewOperator';
import ViewRegion from '../../pages/Region/ViewRegion';
import ListSources from '../../pages/Source/ListSources';
import ListTransfers from '../../pages/Transfer/ListTransfers';
import ListWells from '../../pages/Well/ListWells';
import ViewWell from '../../pages/Well/ViewWell';
import NotFoundError from '../NotFoundError';
import PrivateRoute from '../PrivateRoute';

interface RoutesProps {
  authUser?: UpstreamToken;
  authError?: string;
}

const AdminRoutes = Loadable({
  loader: () => import('./AdminRoutes'),
  loading: () => <div />,
});

export default (props: RoutesProps) => {
  const { pathname } = useLocation();
  const { authUser, authError } = props;
  const redirectToLogin = <Redirect to={{ pathname: paths.LOGIN, state: { redirectTo: pathname } }} />;
  const redirectToTopRegion = <Redirect to={{ pathname: paths.VIEW_REGION.replace(':id', ROOT_REGION_ID_STRING) }} />;

  return (
    <>
      <Switch>
        <Route exact path={paths.LOGIN}>
          <Login />
        </Route>
        <Route exact path={paths.LOGIN_WITH_TOKEN}>
          <LoginWithToken />
        </Route>
        <Route exact path={paths.LOGOUT}>
          <Logout />
        </Route>

        {/* Redirect on an authentication error, but only if none of the above routes matched. */}
        {authError && <Route>{redirectToLogin}</Route>}

        <PrivateRoute exact path={paths.HOME}>
          <Home />
        </PrivateRoute>

        <PrivateRoute exact path={paths.LIST_OPERATORS}>
          <ListOperators />
        </PrivateRoute>
        <PrivateRoute exact path={paths.VIEW_OPERATOR}>
          <ViewOperator />
        </PrivateRoute>

        <PrivateRoute exact path={paths.LIST_REGIONS}>
          {/*<ListRegions />*/}
          {redirectToTopRegion}
        </PrivateRoute>
        <PrivateRoute exact path={paths.VIEW_REGION}>
          <ViewRegion />
        </PrivateRoute>

        <PrivateRoute exact path={paths.LIST_SOURCES}>
          <ListSources />
        </PrivateRoute>

        <PrivateRoute exact path={paths.LIST_TRANSFERS}>
          <ListTransfers />
        </PrivateRoute>

        <PrivateRoute exact path={paths.LIST_WELLS}>
          <ListWells />
        </PrivateRoute>
        <PrivateRoute exact path={paths.VIEW_WELL}>
          <ViewWell />
        </PrivateRoute>

        <PrivateRoute path={paths.admin.ROOT}>
          {authUser?.canDataEntry ? <AdminRoutes /> : <Redirect to={paths.HOME} />}
        </PrivateRoute>

        <PrivateRoute>
          <NotFoundError />
        </PrivateRoute>
      </Switch>
    </>
  );
};
